import { useCallback, useState } from 'react'
import { Server, Gamepad2 } from 'lucide-react'
import AdminScreenShell, { StatusRij } from '@/components/AdminScreenShell'
import { pterodactylAPI, gameServersAPI } from '@/lib/api'

export default function AdminServersScreen() {
  const [servers, setServers] = useState([])
  const [ptero, setPtero]     = useState([])
  const [err, setErr]         = useState(null)

  const load = useCallback(async () => {
    try {
      const [s, p] = await Promise.all([
        gameServersAPI.getServers().catch(() => ({ data: { servers: [] } })),
        pterodactylAPI.getServers(true).catch(() => ({ data: { servers: [] } })),
      ])
      setServers(s.data?.servers ?? [])
      setPtero(p.data?.servers ?? [])
      setErr(null)
    } catch (e) { setErr(e.message) }
  }, [])

  return (
    <AdminScreenShell title="Servers" subtitle="Wat er nu draait op de LAN"
                      icon={Server} accent="#61E294" onRefresh={load}>
      {err && <div className="text-signal text-sm mb-4">{err}</div>}

      <div className="grid gap-6 md:grid-cols-2">
        <section>
          <h2 className="font-mono text-[11px] uppercase tracking-[0.3em] text-muted-foreground mb-3">
            Pterodactyl · {ptero.length} server(s)
          </h2>
          <div className="rounded-[6px] border border-border bg-card px-4">
            {ptero.length === 0 && <p className="py-3 text-sm text-muted-foreground">Niets gevonden.</p>}
            {ptero.map(s => {
              const online = String(s.status || '').toLowerCase() === 'running'
              return (
                <StatusRij key={s.identifier || s.id}
                           naam={s.name || s.identifier}
                           sub={`${s.node || ''} · ${s.ip || s.allocation?.ip || ''}:${s.port || s.allocation?.port || '?'}`}
                           status={online ? 'live' : (s.status || 'onbekend')}
                           kleur={online ? '#61E294' : '#94A3B8'} />
              )
            })}
          </div>
        </section>

        <section>
          <h2 className="font-mono text-[11px] uppercase tracking-[0.3em] text-muted-foreground mb-3">
            <Gamepad2 className="inline h-3 w-3 mr-1" /> Andere servers · {servers.length}
          </h2>
          <div className="rounded-[6px] border border-border bg-card px-4">
            {servers.length === 0 && <p className="py-3 text-sm text-muted-foreground">Niets gevonden.</p>}
            {servers.map(s => (
              <StatusRij key={s.id}
                         naam={s.name || s.game_name}
                         sub={`${s.game_name || ''} · ${s.ip}:${s.port} · ${s.current_players ?? 0}/${s.max_players ?? '?'}`}
                         status={s.is_online ? 'online' : 'offline'}
                         kleur={s.is_online ? '#61E294' : '#94A3B8'} />
            ))}
          </div>
        </section>
      </div>
    </AdminScreenShell>
  )
}
